import { render, staticRenderFns } from "./DialogConfirmClosePo.vue?vue&type=template&id=2c695acc&"
import script from "./DialogConfirmClosePo.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmClosePo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports